import { ViewAllProps } from '../../types';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { getSeoUrl } from 'utils/links';
import { HEADLESS_MY_EQUIPMENT_LINK } from 'constants/links';
import styles from './view-all.module.scss';

export const ViewAll = ({ children }: Readonly<ViewAllProps>) => {
  const params: esiteParams = useParams();
  const myEquipmentLink = getSeoUrl(params, HEADLESS_MY_EQUIPMENT_LINK);

  return (
    <Link
      href={{ pathname: myEquipmentLink }}
      className={styles['ghost-button']}
    >
      {children}
    </Link>
  );
};
